import tinycolor from 'tinycolor2';
import App from './App.svelte';
//import 'i18n/i18n';
import {
  addMessages,
  init,
  getLocaleFromNavigator,
} from 'precompile-intl-runtime';
import en from '../messages/en.js';
import sv from '../messages/sv.js';
import { enablePatches } from 'immer';

addMessages('en', en);
addMessages('sv', sv);

let locale = getLocaleFromNavigator();
//locale = 'en';
let queryParams = {};
location.search
  .split(/\?|;/)
  .filter((l) => l.length > 0)
  .forEach((m) => {
    let t = m.split('=');
    queryParams[t[0]] = t[1];
  });

if (queryParams.lang !== undefined) {
  locale = queryParams.lang;
}

init({
  fallbackLocale: 'en',
  initialLocale: locale,
});

/*
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('serviceworker.js', { scope: './' })
    .then((reg) => {
      // registration worked
      console.log('Registration succeeded. Scope is ' + reg.scope);
    })
    .catch((error) => {
      // registration failed
      console.log('Registration failed with ' + error);
    });
}
*/

enablePatches();
window.process = { env: { NODE_ENV: 'production' } };

console.log('lol', locale);
const app = new App({
  target: document.body,
  props: {
    locale: locale.split('-')[0],
  },
});

window.tinycolor = tinycolor;
export default app;
